import InputModel from '../../shared/components/InputModel/InputModel';

export default class OrderNumberInputModel extends InputModel {
  getLabelAndValue() {
    return this.value ? [{ label: `Order #: ${this.value}`, value: this.value }] : [];
  }
}
